export default function EpochTimeToLocaleString(timeEpoch, offset){
    var d = new Date(timeEpoch * 1000);
    var date = d.toLocaleDateString()
    var time = d.toLocaleTimeString()
    return date + " " + time
}